import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  otherChargesreport: [],
  loading: false,
  error: null,
};

const dailyOtherReportSlice = createSlice({
  name: "dailyOtherReport",
  initialState,
  reducers: {
    fetchDailyOtherReportSheetStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDailyOtherReportSheetSuccess(state, action) {
      state.otherChargesreport = action.payload.otherChargesreport;
      state.loading = false;
      state.error = null;
    },
    fetchDailyOtherReportSheetFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // addSupplierStart(state) {
    //   state.loading = true;
    //   state.error = null;
    // },
    // addSupplierSuccess(state, action) {
    //   state.loading = false;
    //   state.suppliers.unshift(action.payload);
    //   state.error = null;
    // },
    // addSupplierFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    // deleteSupplierStart(state) {
    //   state.loading = true;
    //   state.error = null;
    // },
    // deleteSupplierSuccess(state, action) {
    //   state.loading = false;
    //   state.suppliers = state.suppliers.filter(
    //     (supplier) => supplier.id !== action.payload
    //   );
    //   state.error = null;
    // },
    // deleteSupplierFailure(state, action) {
    //   state.loading = true;
    //   state.error = action.payload;
    // },
    // editSupplierStart(state) {
    //   state.loading = true;
    //   state.error = null;
    // },
    // editSupplierSuccess(state, action) {
    //   state.loading = false;
    //   const updatedSupplier = action.payload;
    //   const index = state.suppliers.findIndex(
    //     (supplier) => supplier.id === updatedSupplier.id
    //   );
    //   if (index !== -1) {
    //     state.suppliers[index] = updatedSupplier;
    //   }
    //   state.error = null;
    // },
    // editSupplierFailure(state, action) {
    //   state.loading = true;
    //   state.error = action.payload;
    // },

    // getCategoryByIdStart(state) {
    //   state.loading = false;
    //   state.error = null;
    //   state.selectedCategory = null;
    // },
    // getCategoryByIdSuccess(state, action) {
    //   state.loading = false;
    //   state.selectedCategory = action.payload;
    //   state.error = null;
    // },
    // getCategoryByIdFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    resetDailyOtherReports(state) {
      state.otherChargesreport = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchDailyOtherReportSheetStart,
  fetchDailyOtherReportSheetSuccess,
  fetchDailyOtherReportSheetFailure,
  //   addSupplierStart,
  //   addSupplierSuccess,
  //   addSupplierFailure,
  //   deleteSupplierStart,
  //   deleteSupplierSuccess,
  //   deleteSupplierFailure,
  //   editSupplierStart,
  //   editSupplierSuccess,
  //   editSupplierFailure,
  //   getCategoryByIdFailure,
  //   getCategoryByIdStart,
  //   getCategoryByIdSuccess,
  resetDailyOtherReports,
} = dailyOtherReportSlice.actions;

export default dailyOtherReportSlice.reducer;
